<template>
  <div>
    <a-modal @ok="() => {this.expandImg = false}" :cancel-button-props="{props: { disabled: true } }" width="400px"
             v-model="expandImg" :title="nombre" :footer="null">
      <a-card hoverable style="width: auto">
        <img
          slot="cover"
          :src="profileSrc"
        />
      </a-card>
    </a-modal>
    <a-spin :spinning="loading">
      <a-form-model layout="vertical" :model="iEmployee" :rules="formRules"
                    @submit="guardarDatosLaborales"
                    @submit.native.prevent ref="datosLaboralesForm">
        <a-tabs :active-key="keyTab" @change="changeTab">
          <a-tab-pane key="0" force-render>
          <span slot="tab">
            <a-icon type="info-circle"/>
            Información de Contrato
          </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <template v-if="visible_id_h_att1">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Grupo')" prop="id_h_att1" has-feedback>
                      <form-model-dropdown style="width: 100%"
                                           v-model="iEmployee.id_h_att1"
                                           endpoint="hierarchy_lookup"
                                           :params="request.id_h_att1"
                                           :selectedObj.sync="grupoSeleccionado"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                </template>
                <template v-if="visible_id_h_att2">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('Puesto')" prop="id_h_att2" has-feedback>
                      <form-model-dropdown style="width: 100%"
                                           v-model="iEmployee.id_h_att2"
                                           endpoint="hierarchy_lookup"
                                           :params="puestoParams"
                                           :selectedObj.sync="puestoSeleccionado"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                </template>
                <template v-if="visible_id_h_att3">
                  <a-col v-bind="colSpan">
                    <a-form-model-item :label="$t('ID_H_ATT3')" prop="id_h_att3" has-feedback>
                      <form-model-dropdown style="width: 100%"
                                           v-model="iEmployee.id_h_att3"
                                           endpoint="hierarchy_lookup"
                                           :params="request.id_h_att3"
                      ></form-model-dropdown>
                    </a-form-model-item>
                  </a-col>
                </template>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Compañía')" prop="company" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         endpoint="company"
                                         v-model="iEmployee.company"
                    >
                    </form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Oficina')" prop="location" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         endpoint="offices"
                                         v-model="iEmployee.location"
                                         :disabled="!$isEmpty(iEmployee.location)"
                    >
                    </form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Id cliente')" prop="id_marsh" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iEmployee.id_marsh"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Id Empleado')" prop="id_emp" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iEmployee.id_emp"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Número Contrato')" prop="contract_number" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iEmployee.contract_number"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Estado')" prop="status" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.status"
                                         endpoint="hierarchy_lookup"
                                         :params="request.status"
                                         :disabled="!canEdit"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo de Contrato')" prop="id_h_contract_type" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_contract_type"
                                         endpoint="hierarchy_lookup"
                                         :selectedObj.sync="tipoContrato"
                                         :params="request.id_h_contract_type"
                                         ref="tipoContrato"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha Inicio Contrato')" prop="initial_date" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.initial_date"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha Fin Contrato')" :key="keyEndDate" prop="end_date" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.end_date"
                                   :disabled="!canEdit"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Sistema de Vacaciones')" prop="id_h_vacation_system" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_vacation_system"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_vacation_system"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo pago')" prop="tpay" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.tpay"
                                         endpoint="hierarchy_lookup"
                                         :params="request.tpay"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Frecuencia Liquidación')" prop="tliq" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.tliq"
                                         endpoint="hierarchy_lookup"
                                         :params="request.tliq"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Motivo de retiro')" prop="id_h_termination_cause" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_termination_cause"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_termination_cause"
                                         :disabled="!canEdit"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha de retiro')" prop="termination_date" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.termination_date"
                                   :disabled="!canEdit"/>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="1" force-render>
          <span slot="tab">
            <a-icon type="info-circle"/>
            Información del cargo y estructura
          </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Cargo')" prop="job" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.job"
                                         endpoint="jobs"
                                         :params="paramsJobs"
                                         :disabled="!$isEmpty(iEmployee.job)"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Jefe')" prop="id_boss_emp" compact>
                    <a-row>
                      <a-col :span="22">
                        <form-model-lookup style="width: 100%"
                                           v-model="iEmployee.id_boss_emp"
                                           endpoint="boss"
                                           :formItemConfig="fiOptions"
                                           :selectedObj.sync="infoBasicEmployee"
                        >
                        </form-model-lookup>
                      </a-col>
                      <a-col :span="2">
                        <a-avatar @click="agrandarImg()" style="max-width: 100px" shape="square" :src="profileSrc"/>
                      </a-col>
                    </a-row>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Org1')" prop="id_level1" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_level1"
                                         endpoint="level1"
                                         :selectedObj.sync="org1Seleccionado"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                {{iEmployee.level1}}
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Org2')" prop="id_level2" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_level2"
                                         endpoint="level2"
                                         :params="level2Params"
                                         :selectedObj.sync="org2Seleccionado"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Org3')" prop="id_level3" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_level3"
                                         endpoint="level3"
                                         :params="level3Params"
                                         :selectedObj.sync="org3Seleccionado"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Org4')" prop="id_level4" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_level4"
                                         endpoint="level4"
                                         :params="level4Params"
                                         :selectedObj.sync="org4Seleccionado"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Org5')" prop="id_level5" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_level5"
                                         endpoint="level5"
                                         :params="level5Params"
                                         :selectedObj.sync="org5Seleccionado"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Org6')" prop="id_level6" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_level6"
                                         endpoint="level6"
                                         :params="level6Params"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('ID Posición')" prop="position" has-feedback>
                    <a-input style="width: 100%" v-model="iEmployee.position"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>

          <a-tab-pane key="2" force-render>
          <span slot="tab">
            <a-icon type="info-circle"/>
            Información del fondo y pago
          </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fondo Empleados')" prop="fund_emp" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.fund_emp"
                                         endpoint="hierarchy_lookup"
                                         :params="request.estado_sn"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('% Fondo')" prop="id_percent_fund_emp" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_percent_fund_emp"
                                         endpoint="hierarchy_lookup"
                                         :params="request.porcentaje_creciat"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha Afiliación Fondo')" prop="fund_affiliation_date" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.fund_affiliation_date"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha Finalización Fondo')" prop="fund_termination_date" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.fund_termination_date"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha Sustitución Patronal')" prop="union_affiliation_date"
                                     has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.union_affiliation_date"/>
                  </a-form-model-item>
                </a-col>

                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Forma de Pago')" prop="id_h_payment_form" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_payment_form"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_payment_form"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Moneda Liq.')" prop="id_h_currency_liq" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_currency_liq"
                                         endpoint="hierarchy_lookup"
                                         :params="request.money"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Moneda Pago.')" prop="id_h_currency_pay" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_currency_pay"
                                         endpoint="hierarchy_lookup"
                                         :params="request.money"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tipo salario')" prop="tsalary" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.tsalary"
                                         endpoint="tsalary"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>


              </a-row>
            </a-card>
          </a-tab-pane>

          <a-tab-pane key="3" force-render>
          <span slot="tab">
            <a-icon type="info-circle"/>
            Otra información
          </span>
            <a-card>
              <a-row :gutter="[16,16]">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Nivel 1')" prop="n1" has-feedback>
                    <a-input readOnly style="width: 100%" v-model="iEmployee.n1"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Causa de Admisión')" prop="id_h_admission_reason" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_admission_reason"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_admission_reason"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>

                <a-col v-if="ocultarCampoFuenteReclutamiento" v-bind="colSpan">
                  <a-form-model-item :label="$t('Fuente de Reclutamiento')" prop="id_h_recruitment_source" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_recruitment_source"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_recruitment_source"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>

                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Jornada Laboral')" prop="id_h_working_day" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_working_day"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_working_day"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Horas Laboradas')" prop="working_hours" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iEmployee.working_hours"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Categoría')" prop="id_h_category" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_category"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_category"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Relación Empleado')" prop="id_h_emp_relationship" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_emp_relationship"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_emp_relationship"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>

                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Fecha de Extensión')" prop="extension_date" has-feedback>
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-model="iEmployee.extension_date"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Clase de Empleado')" prop="id_h_class_emp" has-feedback>
                    <form-model-dropdown style="width: 100%"
                                         v-model="iEmployee.id_h_class_emp"
                                         endpoint="hierarchy_lookup"
                                         :params="request.id_h_class_emp"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('RH Code')" prop="rh_code" has-feedback>
                    <a-input style="width: 100%"
                             v-model="iEmployee.rh_code"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Creado por')" prop="created_by" has-feedback>
                    {{iEmployee.created_by}}
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Creado')" prop="created_on" has-feedback>
                    {{iEmployee.created_on}}
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Modificado por')" prop="modified_by" has-feedback>
                    {{iEmployee.modified_by}}
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Modificado')" prop="modified_on" has-feedback>
                    {{iEmployee.modified_on}}
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>
        </a-tabs>
        <a-affix :offset-bottom="10" v-if="canEdit">
          <a-card style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
            <a-button v-if="!$userIsInrol('Query')"
              type="primary"
              html-type="submit">
              Guardar Cambios
            </a-button>
          </a-card>
        </a-affix>
      </a-form-model>
    </a-spin>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  const fieldsTabOne = [
    'id_h_att1',
    'id_h_att2',
    'id_h_att3',
    'location',
    'id_h_contract_type',
    'initial_date',
    'tliq',
    'id_h_vacation_system',
    'end_date'
  ]

  const fieldsTabTwo = [
    'id_boss_emp',
    'id_h_currency_pay'
  ]

  const fieldsTabThree = [
    'id_h_payment_form',
    'tsalary',
    'id_h_currency_liq',
    'id_h_currency_pay'
  ]

  const fieldsTabFour = [
    'id_h_class_emp',
    'id_h_category'
  ]

  const fieldsTab = [
    fieldsTabOne,
    fieldsTabTwo,
    fieldsTabThree,
    fieldsTabFour
  ]

  function searchFields (field) {
    for (let i = 0; i < fieldsTab.length; i++) {
      if (fieldsTab[i].includes(field)) {
        return i
      }
    }
  }

  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        nombre: 'Foto de perfil',
        expandImg: false,
        profileSrc: require('./../../assets/anon_profile.png'),
        defaultPicture: require('./../../assets/anon_profile.png'),
        infoBasicEmployee: {},
        keyTab: '0',
        visible_id_h_att1: this.$getConfigValue('HOJADEVIDA_VISIBLE_ID_H_ATT1', false) === 'SI',
        visible_id_h_att2: this.$getConfigValue('HOJADEVIDA_VISIBLE_ID_H_ATT2', false) === 'SI',
        visible_id_h_att3: this.$getConfigValue('HOJADEVIDA_VISIBLE_ID_H_ATT3', false) === 'SI',
        modalDireccionVisible: false,
        loading: false,
        grupoSeleccionado: {},
        puestoSeleccionado: {},
        org1Seleccionado: {},
        org2Seleccionado: {},
        org3Seleccionado: {},
        org4Seleccionado: {},
        org5Seleccionado: {},
        colSpan: {
          xs: 24,
          md: 8
        },
        iEmployee: {},
        formRules: {},
        fiChkOptions: {
          'wrapper-col': {
            offset: 8,
            span: 16
          }
        },
        request: {
          status: {
            h_lookup_type: 'ESTADO_EMPLEADO',
            use_equivalency: true
          },
          id_h_contract_type: {
            h_lookup_type: 'TIPO_CONTRATO'
          },
          tliq: {
            h_lookup_type: 'TIPO_LIQUIDACION',
            use_code: true
          },
          tpay: {
            h_lookup_type: 'TIPO PAGO',
            use_code: true
          },
          id_h_termination_cause: {
            h_lookup_type: 'CAUSA_RETIRO'
          },
          id_h_payment_form: {
            h_lookup_type: 'FORMA_PAGO_NOMINA'
          },
          money: {
            h_lookup_type: 'MONEDA'
          },
          estado_sn: {
            h_lookup_type: 'ESTADO_SN',
            use_code: true
          },
          porcentaje_creciat: {
            h_lookup_type: 'PORCENTAJE_CRECIAT'
          },
          id_h_vacation_system: {
            h_lookup_type: 'SISTEMA_VACACIONES'
          },
          id_h_admission_reason: {
            h_lookup_type: 'MOTIVO_INGRESO'
          },
          id_h_recruitment_source: {
            h_lookup_type: 'FUENTE_RECLUTAMIENTO'
          },
          id_h_working_day: {
            h_lookup_type: 'JORNADA_TRABAJO'
          },
          id_h_category: {
            h_lookup_type: 'CATEGORIA'
          },
          id_h_emp_relationship: {
            h_lookup_type: 'RELACION_LABORAL'
          },
          id_h_class_emp: {
            h_lookup_type: 'CLASE_EMPLEADO'
          },
          id_h_att1: {
            h_lookup_type: 'ID_H_ATT1'
          },
          id_h_att2: {
            h_lookup_type: 'ID_H_ATT2'
          },
          id_h_att3: {
            h_lookup_type: 'ID_H_ATT3'
          },
          zona: {
            h_lookup_type: 'ZONA'
          }
        },
        dropdown: {
          country_expedition_selected: {},
          country_birth_selected: {}
        },
        flags: FLAGS,
        canEdit: false,
        tipoContrato: {},
        keyEndDate: 0
      }
    },
    props: ['empleadoseleccionado'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
      this.initFormRules()
    },
    computed: {
      ocultarCampoFuenteReclutamiento () {
        let ocultarCampoFuenteReclutamiento = this.$getConfigValue('MOSTRAR_CAMPO_FUENTE_RECLUTAMIENTO_HV_MASIVO')
        if (this.$isEmpty(ocultarCampoFuenteReclutamiento) || ocultarCampoFuenteReclutamiento === 'SI') {
          return true
        } else {
          return false
        }
      },
      paramsJobs () {
        if (!this.$isEmpty(this.iEmployee.job)) {
          return {status: 'ALL'}
        }
      },
      puestoParams () {
        if (this.$isEmpty(this.grupoSeleccionado)) {
          return {
            h_lookup_type: 'ID_H_ATT2'
          }
        } else {
          return {
            h_lookup_type: 'ID_H_ATT2',
            id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : this.puestoSeleccionado.value
          }
        }
      },
      level2Params () {
        if (!this.$isEmpty(this.org1Seleccionado)) {
          return {
            id_level1: this.org1Seleccionado.value
          }
        }
      },
      level3Params () {
        if (!this.$isEmpty(this.org2Seleccionado)) {
          return {
            id_level2: this.org2Seleccionado.value
          }
        }
      },
      level4Params () {
        if (!this.$isEmpty(this.org3Seleccionado)) {
          return {
            id_level3: this.org3Seleccionado.value
          }
        }
      },
      level5Params () {
        if (!this.$isEmpty(this.org4Seleccionado)) {
          return {
            id_level4: this.org4Seleccionado.value
          }
        }
      },
      level6Params () {
        if (!this.$isEmpty(this.org5Seleccionado)) {
          return {
            id_level5: this.org5Seleccionado.value
          }
        }
      }
    },
    methods: {
      changeTab (e) {
        this.keyTab = e
      },
      agrandarImg () {
        this.expandImg = true
      },
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      loadData () {
        if (JsUtils.isEmpty(this.empleadoseleccionado)) {
          return
        }
        this.loading = true
        this.httpClient.getInstance().get('employee/consultardatoslaborales/' + this.empleadoseleccionado)
          .then(response => {
            this.iEmployee = {...response.data}
            this.canEdit = this.iEmployee.status !== 'R'
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos personales, contacte al administrador.')
          })
          .then(() => {
            this.loading = false
          })
      },
      guardarDatosLaborales () {
        if (this.loading) return
        this.$refs.datosLaboralesForm.validate((valid, fields) => {
          Object.keys(fields).forEach(field => {
            this.keyTab = searchFields(field) + ''
            return 0
          }
          )
          if (valid) {
            this.loading = true
            let req = this.iEmployee
            req['id_level1'] = typeof req.id_level1 === 'undefined' ? null : req.id_level1
            this.httpClient.getInstance().post('employee/guardardatoslaborales', req)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
                this.loadData()
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      initFormRules () {
        this.formRules = {
          id_h_att1: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_ATT1', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_att2: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_ATT2', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_att3: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_ATT3', false) === 'SI',
            message: 'Valor requerido'
          }],
          location: [{
            required: this.$getConfigValue('HOJADEVIDA_REQURIDO_LOCATION', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_boss_emp: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_BOSS', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_currency_pay: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_CURRENCY_PAY', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_class_emp: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_CLASS_EMP', false) === 'SI',
            message: 'Valor requerido'
          }],
          code_bank: [{required: false}],
          contract_number: [{required: false}],
          end_date: [{required: false, message: 'Valor requerido'}],
          extension_date: [{required: false}],
          fund_affiliation_date: [{required: false}],
          fund_emp: [{required: false}],
          fund_termination_date: [{required: false}],
          id_h_admission_reason: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_ADMISSION_REASON', false) === 'SI',
            message: 'Valor requerido'}],
          id_h_category: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_CATEGORY', false) === 'SI',
            message: 'Valor requerido'}],
          id_h_contract_type: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_CONTRACT_TYPE', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_currency_liq: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_CURRENCY_LIQ', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_emp_relationship: [{required: false}],
          id_h_payment_form: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_PAYMENT_FORM', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_payroll_type: [{required: false}],
          id_h_recruitment_source: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_RECRUITMENT_SOURCE', false) === 'SI',
            message: 'Valor requerido'}],
          id_h_status_emp: [{required: false}],
          id_h_termination_cause: [{required: false}],
          id_h_vacation_system: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_ID_H_VACATION_SYSTEM', false) === 'SI',
            message: 'Valor requerido'
          }],
          id_h_working_day: [{required: false}],
          id_level1: [{required: false}],
          id_level2: [{required: false}],
          id_level3: [{required: false}],
          id_level4: [{required: false}],
          id_level5: [{required: false}],
          id_level6: [{required: false}],
          id_marsh: [{required: false}],
          id_percent_fund_emp: [{required: false}],
          id_person: [{required: false}],
          identificardor_hv: [{required: false}],
          initial_date: [{required: true, message: 'Valor requerido'}],
          job: [{required: false}],
          n1: [{required: false}],
          n2: [{required: false}],
          n3: [{required: false}],
          n4: [{required: false}],
          n5: [{required: false}],
          position: [{required: false}],
          rh_code: [{required: false}],
          status: [{required: false}],
          termination_date: [{required: false}],
          termination_reason: [{required: false}],
          tliq: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_TLIQ', false) === 'SI',
            message: 'Valor requerido'
          }],
          tpay: [{required: false}],
          tsalary: [{
            required: this.$getConfigValue('HOJADEVIDA_REQUERIDO_TSALARY', false) === 'SI',
            message: 'Valor requerido'
          }],
          union_affiliation_date: [{required: false}],
          working_hours: [{required: false}]
        }
        this.fechaFinContrato()
      },
      loadPersonPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      },
      fechaFinContrato () {
        if (this.$getConfigValue('MASIVO_FECHA_FIN_CONTRATO_REQUERIDA', 'SI') === 'SI') {
          this.$refs.tipoContrato && this.$refs.tipoContrato.handleChange(this.iEmployee.id_h_contract_type)
          this.formRules.end_date[0].required = !['I', 'TI', 'IND', 'OBR'].includes(this.tipoContrato.code)
          this.keyEndDate++
        }
      }
    },
    watch: {
      empleadoseleccionado () {
        this.loadData()
      },
      infoBasicEmployee () {
        if (!JsUtils.isEmpty(this.infoBasicEmployee)) {
          this.loadPersonPicture(this.infoBasicEmployee.value)
        }
      },
      'iEmployee.id_h_contract_type': function () {
        this.fechaFinContrato()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/InformacionLaboral.vue